import { PinCell } from "@/components/PinCell";

// Renders one A4 page at a given ppmm scale with 15 pin cells using a dynamic layout.
export function PinCanvas({
  page, pageIdx, layout, ppmm, selected, nextEmpty, showCenter,
  centerDotSize = 2.4, centerDotColor = "#e22020",
  onSelectCell, onChangeTransform, testId, projectId,
}) {
  const widthPx = layout.PAGE_W * ppmm;
  const heightPx = layout.PAGE_H * ppmm;

  return (
    <div
      data-testid={testId || "editor-a4-canvas"}
      className="relative mx-auto rounded-none border border-[hsl(var(--paper-edge))] bg-[hsl(var(--paper))] shadow-[0_18px_50px_rgba(15,23,42,0.12)]"
      style={{ width: widthPx, height: heightPx }}
    >
      {page.cells.map((cell, i) => {
        const isSel = selected && selected.pageIdx === pageIdx && selected.cellIdx === i;
        const isNext = nextEmpty && nextEmpty.pageIdx === pageIdx && nextEmpty.cellIdx === i;
        return (
          <PinCell
            key={i}
            cell={cell}
            projectId={projectId}
            index={i}
            layout={layout}
            ppmm={ppmm}
            selected={isSel}
            isNextEmpty={isNext}
            showCenter={showCenter}
            centerDotSize={centerDotSize}
            centerDotColor={centerDotColor}
            onSelect={() => onSelectCell(pageIdx, i)}
            onChangeTransform={(patch) => onChangeTransform(pageIdx, i, patch)}
          />
        );
      })}
    </div>
  );
}
